/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface EnrollmentStatusRow
 */
export interface EnrollmentStatusRow {
    /**
     * 
     * @type {string}
     * @memberof EnrollmentStatusRow
     */
    status: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentStatusRow
     */
    count: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the EnrollmentStatusRow interface.
 */
export function instanceOfEnrollmentStatusRow(value: object): value is EnrollmentStatusRow {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function EnrollmentStatusRowFromJSON(json: any): EnrollmentStatusRow {
    return EnrollmentStatusRowFromJSONTyped(json, false);
}

export function EnrollmentStatusRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentStatusRow {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
    };
}

export function EnrollmentStatusRowToJSON(json: any): EnrollmentStatusRow {
    return EnrollmentStatusRowToJSONTyped(json, false);
}

export function EnrollmentStatusRowToJSONTyped(value?: EnrollmentStatusRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
    };
}

